// Comprehensive translation dictionaries for the entire website
// Spanish is the default language

export const translations = {
  es: {
    // Navbar
    navbar: {
      home: 'Inicio',
      forSale: 'En Venta',
      forRent: 'En Alquiler',
      sold: 'Vendidas',
      reposeidas: 'Reposeídas',
      aboutUs: 'Conócenos',
      ourTeam: 'Nuestro Equipo',
      contact: 'Contacto',
      resources: 'Recursos',
      mls: 'MLS',
      dashboard: 'Panel de Control',
      logout: 'Cerrar Sesión',
      login: 'Iniciar Sesión',
    },

    // Footer
    footer: {
      contact: 'Contacto',
      email: 'Correo',
      phone: 'Teléfono',
      quickLinks: 'Enlaces Rápidos',
      home: 'Inicio',
      forSale: 'En Venta',
      forRent: 'En Alquiler',
      aboutUs: 'Conócenos',
      allRightsReserved: 'Todos los derechos reservados',
      developedBy: 'Desarrollado por',
      adminAccess: 'Acceso de Administrador',
      followUs: 'Síguenos',
      equalHousingOpportunity: 'Oportunidad de Vivienda Igualitaria',
      realtorLogo: 'Logo de Realtor',
    },

    // Home page
    home: {
      heroTitle: 'Encuentre la Casa de Tus Sueños',
      heroSubtitle: 'Descubra la propiedad perfecta con Alicea Realty Group LLC',
      commitment: 'Nuestro Compromiso',
      commitmentText1: 'Como agencia inmobiliaria, representamos de manera exclusiva los intereses de nuestros clientes, vendedores o compradores, que nos hayan otorgado un mandato firme para la venta o adquisición de un inmueble. Brindamos asesoramiento integral y gestionamos cada operación con profesionalismo, transparencia y responsabilidad, buscando siempre maximizar la rentabilidad para cada propietario.',
      commitmentText2: 'Nos encargamos de todo el proceso de forma personalizada, optimizando tiempos y recursos. Contamos con medios técnicos y humanos para mantener a nuestros clientes informados puntualmente sobre el avance de las gestiones y cualquier circunstancia relevante que pueda afectar la operación.',
      certifications: 'Certificaciones',
      memberships: 'Membresías',
    },

    // About page
    about: {
      title: 'Acerca de',
      mission: 'Nuestra Misión',
      missionText: 'Proporcionar un asesoramiento integral, a personas y empresas, que permita solucionar todas sus necesidades relacionadas con el mercado inmobiliario. Aportándoles una mayor rentabilidad basada en la responsabilidad y la transparencia.',
      vision: 'Nuestra Visión',
      visionText: 'Convertirnos en la empresa de referencia del sector inmobiliario de su preferencia, con él único objeto de que las personas que intervienen en este mercado piensen en nosotros como primera opción en el momento de vender, comprar o alquilar una vivienda.',
      values: 'Nuestros Valores',
      valuesText: 'Transparencia, Ética – Honestidad, Profesionalidad, Respeto, Confianza, Eficiencia y Responsabilidad Social.',
    },

    // Contact page
    contact: {
      title: 'Contáctenos',
      subtitle: 'Estamos aquí para ayudarlo',
      name: 'Nombre',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      message: 'Mensaje',
      send: 'Enviar',
      sending: 'Enviando...',
      successMessage: '¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.',
      errorMessage: 'Hubo un problema al enviar el mensaje. Por favor, intente nuevamente.',
      configError: 'Error de configuración. Por favor, contacte al administrador.',
      connectionError: 'Error al enviar el mensaje. Por favor, verifique su conexión e intente nuevamente.',
      notProvided: 'No proporcionado',
      officeHours: 'Horario de Oficina',
      location: 'Ubicación',
      getInTouch: 'Póngase en Contacto',
    },

    // Search bar
    search: {
      city: 'Pueblo',
      bathrooms: 'Baños',
      bedrooms: 'Habitaciones',
      listingType: 'Tipo',
      forSale: 'En Venta',
      forRent: 'En Alquiler',
      priceRange: 'Rango de Precio',
      allPrices: 'Todos los Precios',
      search: 'Buscar',
    },

    // Property types
    propertyType: {
      house: 'Casa',
      apartment: 'Apartamento',
      condo: 'Condominio',
      walkup: 'Walk Up',
      multifamiliar: 'Multifamiliar',
      finca: 'Finca',
      duplex: 'Duplex',
      land: 'Terreno',
      commercial: 'Comercial',
    },

    // Property status
    status: {
      available: 'Disponible',
      pending: 'Opcionada',
      sold: 'Vendida',
      rented: 'Rentada',
    },

    // Listing types
    listingType: {
      forSale: 'En Venta',
      forRent: 'En Alquiler',
      sold: 'Vendida',
      archived: 'Archivada',
    },

    // Common
    common: {
      loading: 'Cargando...',
      noResults: 'No se encontraron resultados',
      viewDetails: 'Ver Detalles',
      contactUs: 'Contáctenos',
      readMore: 'Leer Más',
      showLess: 'Mostrar Menos',
      more: 'Más',
      less: 'Menos',
    },

    // Property details
    propertyDetails: {
      price: 'Precio',
      bedrooms: 'Habitaciones',
      bathrooms: 'Baños',
      area: 'Área',
      description: 'Descripción',
      features: 'Características',
      location: 'Ubicación',
      contactAgent: 'Contactar Agente',
      shareProperty: 'Compartir Propiedad',
    },

    // Login
    login: {
      title: 'Iniciar Sesión',
      username: 'Usuario',
      password: 'Contraseña',
      submit: 'Entrar',
      error: 'Usuario o contraseña incorrectos',
    },

    // Admin Dashboard
    admin: {
      title: 'Panel de Control',
      addProperty: 'Agregar Propiedad',
      editProperty: 'Editar Propiedad',
      deleteProperty: 'Eliminar Propiedad',
      properties: 'Propiedades',
      settings: 'Configuración',
    },

    // Resources page
    resources: {
      title: 'Recursos o Enlaces Útiles',
      subtitle: 'Enlaces útiles para ayudarte en tu proceso de compra de vivienda',
      seoTitle: 'Recursos y Enlaces Útiles | Alicea Realty Group LLC',
      seoDescription: 'Recursos útiles y enlaces para compradores de vivienda en Puerto Rico. Información sobre HUD, financiamiento, y más.',
      visitLink: 'Visitar Enlace',
      resource1Title: 'Departamento de Vivienda y Desarrollo Urbano (HUD)',
      resource1Description: 'Información oficial sobre programas de vivienda, propiedades HUD y recursos para compradores.',
      resource2Title: 'Oficina de Protección Financiera del Consumidor',
      resource2Description: 'Guías y herramientas para ayudarte a entender el proceso de compra de vivienda y opciones de financiamiento.',
      resource3Title: 'Asociación Nacional de Realtors (NAR)',
      resource3Description: 'Recursos educativos, tendencias del mercado y consejos para compradores de vivienda.',
      resource4Title: 'Freddie Mac',
      resource4Description: 'Información sobre préstamos hipotecarios, tasas de interés y programas de vivienda asequible.',
      resource5Title: 'Fannie Mae',
      resource5Description: 'Recursos para compradores de vivienda, calculadoras hipotecarias y programas de asistencia.',
    },

    // MLS page
    mls: {
      title: 'MLS Puerto Rico',
      subtitle: 'Busque propiedades listadas en el MLS de Puerto Rico',
      iframeTitle: 'Listados MLS de Puerto Rico',
    },
  },

  en: {
    // Navbar
    navbar: {
      home: 'Home',
      forSale: 'For Sale',
      forRent: 'For Rent',
      sold: 'Sold',
      reposeidas: 'Foreclosures',
      aboutUs: 'About Us',
      ourTeam: 'Our Team',
      contact: 'Contact',
      resources: 'Resources',
      mls: 'MLS',
      dashboard: 'Dashboard',
      logout: 'Logout',
      login: 'Login',
    },

    // Footer
    footer: {
      contact: 'Contact',
      email: 'Email',
      phone: 'Phone',
      quickLinks: 'Quick Links',
      home: 'Home',
      forSale: 'For Sale',
      forRent: 'For Rent',
      aboutUs: 'About Us',
      allRightsReserved: 'All rights reserved',
      developedBy: 'Developed by',
      adminAccess: 'Admin Access',
      followUs: 'Follow Us',
      equalHousingOpportunity: 'Equal Housing Opportunity',
      realtorLogo: 'Realtor Logo',
    },

    // Home page
    home: {
      heroTitle: 'Find Your Dream Home',
      heroSubtitle: 'Discover the perfect property with Alicea Realty Group LLC',
      commitment: 'Our Commitment',
      commitmentText1: 'As a real estate agency, we exclusively represent the interests of our clients, whether sellers or buyers, who have granted us a firm mandate for the sale or acquisition of a property. We provide comprehensive advice and manage each transaction with professionalism, transparency, and responsibility, always seeking to maximize profitability for each owner.',
      commitmentText2: 'We take care of the entire process in a personalized way, optimizing time and resources. We have the technical and human means to keep our clients informed promptly about the progress of procedures and any relevant circumstances that may affect the transaction.',
      certifications: 'Certifications',
      memberships: 'Memberships',
    },

    // About page
    about: {
      title: 'About',
      mission: 'Our Mission',
      missionText: 'To provide comprehensive advice to individuals and companies, enabling them to solve all their needs related to the real estate market. Providing them with greater profitability based on responsibility and transparency.',
      vision: 'Our Vision',
      visionText: 'To become the reference company in the real estate sector of your preference, with the sole purpose that people involved in this market think of us as the first option when selling, buying or renting a home.',
      values: 'Our Values',
      valuesText: 'Transparency, Ethics – Honesty, Professionalism, Respect, Trust, Efficiency and Social Responsibility.',
    },

    // Contact page
    contact: {
      title: 'Contact Us',
      subtitle: 'We are here to help you',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      send: 'Send',
      sending: 'Sending...',
      successMessage: 'Message sent successfully! We will contact you soon.',
      errorMessage: 'There was a problem sending the message. Please try again.',
      configError: 'Configuration error. Please contact the administrator.',
      connectionError: 'Error sending message. Please check your connection and try again.',
      notProvided: 'Not provided',
      officeHours: 'Office Hours',
      location: 'Location',
      getInTouch: 'Get in Touch',
    },

    // Search bar
    search: {
      city: 'City',
      bathrooms: 'Bathrooms',
      bedrooms: 'Bedrooms',
      listingType: 'Type',
      forSale: 'For Sale',
      forRent: 'For Rent',
      priceRange: 'Price Range',
      allPrices: 'All Prices',
      search: 'Search',
    },

    // Property types
    propertyType: {
      house: 'House',
      apartment: 'Apartment',
      condo: 'Condo',
      walkup: 'Walk Up',
      multifamiliar: 'Multifamily',
      finca: 'Farm',
      duplex: 'Duplex',
      land: 'Land',
      commercial: 'Commercial',
    },

    // Property status
    status: {
      available: 'Available',
      pending: 'Pending',
      sold: 'Sold',
      rented: 'Rented',
    },

    // Listing types
    listingType: {
      forSale: 'For Sale',
      forRent: 'For Rent',
      sold: 'Sold',
      archived: 'Archived',
    },

    // Common
    common: {
      loading: 'Loading...',
      noResults: 'No results found',
      viewDetails: 'View Details',
      contactUs: 'Contact Us',
      readMore: 'Read More',
      showLess: 'Show Less',
      more: 'More',
      less: 'Less',
    },

    // Property details
    propertyDetails: {
      price: 'Price',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      area: 'Area',
      description: 'Description',
      features: 'Features',
      location: 'Location',
      contactAgent: 'Contact Agent',
      shareProperty: 'Share Property',
    },

    // Login
    login: {
      title: 'Login',
      username: 'Username',
      password: 'Password',
      submit: 'Login',
      error: 'Incorrect username or password',
    },

    // Admin Dashboard
    admin: {
      title: 'Dashboard',
      addProperty: 'Add Property',
      editProperty: 'Edit Property',
      deleteProperty: 'Delete Property',
      properties: 'Properties',
      settings: 'Settings',
    },

    // Resources page
    resources: {
      title: 'Resources or Useful Links',
      subtitle: 'Useful links to help you in your home buying process',
      seoTitle: 'Resources and Useful Links | Alicea Realty Group LLC',
      seoDescription: 'Useful resources and links for home buyers in Puerto Rico. Information about HUD, financing, and more.',
      visitLink: 'Visit Link',
      resource1Title: 'U.S. Department of Housing and Urban Development (HUD)',
      resource1Description: 'Official information about housing programs, HUD properties and resources for home buyers.',
      resource2Title: 'Consumer Financial Protection Bureau',
      resource2Description: 'Guides and tools to help you understand the home buying process and financing options.',
      resource3Title: 'National Association of Realtors (NAR)',
      resource3Description: 'Educational resources, market trends and tips for home buyers.',
      resource4Title: 'Freddie Mac',
      resource4Description: 'Information about mortgage loans, interest rates and affordable housing programs.',
      resource5Title: 'Fannie Mae',
      resource5Description: 'Resources for home buyers, mortgage calculators and assistance programs.',
    },

    // MLS page
    mls: {
      title: 'MLS Puerto Rico',
      subtitle: 'Search properties listed on the Puerto Rico MLS',
      iframeTitle: 'Puerto Rico MLS Listings',
    },
  },
};

// Helper function to get translation
export const getTranslation = (language, path) => {
  const keys = path.split('.');
  let value = translations[language];
  
  for (const key of keys) {
    if (value && typeof value === 'object') {
      value = value[key];
    } else {
      return path; // Return the path if translation not found
    }
  }
  
  return value || path;
};

// Hook to use translations
export const useTranslations = (language) => {
  return {
    t: (path) => getTranslation(language, path),
    translations: translations[language],
  };
};
